import { render } from "./AppBaseState.vue?vue&type=template&id=2c668bba&scoped=true"
import script from "./AppBaseState.vue?vue&type=script&lang=js"
export * from "./AppBaseState.vue?vue&type=script&lang=js"

import "./AppBaseState.vue?vue&type=style&index=0&id=2c668bba&lang=scss&scoped=true"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c668bba"]])

export default __exports__